export const columns = [
  {
    Header: '#',
    accessor: 'id',
  },
  {
    Header: 'Date Start',
    accessor: 'date_start',
  },
  {
    Header: 'Date End',
    accessor: 'date_end',
  },
  {
    Header: 'Type',
    accessor: 'type',
  },

  {
    Header: 'Title',
    accessor: 'title',
  }
];